import React, { useMemo } from 'react';
import { IconButton, MaterialIcons } from '@iclinic/design-system';

import * as S from './VoucherInput.styles';

const { Close, LocalOffer } = MaterialIcons;
type VoucherInputProps = {
  value: string;
  isApplied: boolean;
  error?: string;
  onApply: () => void;
  onRemove: () => void;
  onChange: (value: string) => void;
  isVoucher: boolean;
};
const VoucherInput = ({
  value,
  isApplied,
  error,
  onApply,
  onRemove,
  onChange,
  isVoucher,
}: VoucherInputProps) => {
  const showApplyButton = useMemo(
    () => !value || !isApplied,
    [value, isApplied],
  );

  return (
    <S.VoucherContainerWrapper>
      <S.VoucherInputWrapper>
        <S.TextField
          fullWidth={value !== '' && isApplied}
          disabled={value !== '' && isApplied}
          placeholder="Cupom de desconto"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          error={!!error}
          helperText={error}
          InputProps={{
            startAdornment: <LocalOffer />,
            endAdornment: !showApplyButton && isVoucher && (
              <IconButton
                onClick={onRemove}
                label="Remover cupom"
                tooltip="none"
              >
                <Close fontSize="small" />
              </IconButton>
            ),
          }}
        />

        {showApplyButton && (
          <S.Button
            variant="text"
            size="medium"
            color="transparent"
            onClick={onApply}
          >
            Aplicar
          </S.Button>
        )}
      </S.VoucherInputWrapper>
    </S.VoucherContainerWrapper>
  );
};
export default VoucherInput;
